import { LDFlagSet } from 'launchdarkly-react-client-sdk';

import { LiveReportDetail } from '@futrli-sdk/predict';

import { ApiView, ApiViewState, getDefaultApiViewState } from '../../../core/ApiView';
import { liveReportByIdQuery } from '../../../queries/liveReportById';

export interface ReportDetailViewState extends ApiViewState {
  flags: {
    canEditReport: boolean;
  };
  report: LiveReportDetail | null;
}

export class ReportDetailView extends ApiView {
  private reportObs: ReturnType<typeof liveReportByIdQuery>;

  public state: ReportDetailViewState = {
    ...getDefaultApiViewState(),
    flags: {
      canEditReport: false
    },
    report: null
  };

  constructor(
    workspaceId: string,
    organisationId: string,
    reportId: string | null,
    isConsolidation: boolean,
    private featureFlags: LDFlagSet = {}
  ) {
    super();

    this.reportObs = this.addQuery(
      liveReportByIdQuery(workspaceId, organisationId, reportId ?? '', isConsolidation, {
        enabled: reportId !== null
      })
    );
  }

  protected getNewState(): ReportDetailViewState {
    const report = this.getResult(this.reportObs).data ?? null;

    return {
      ...super.getNewState(),
      flags: {
        canEditReport:
          !this.featureFlags.resourceSharing || report?.permission_info?.effective_permission === 'edit'
      },
      report
    };
  }
}
